{
  "version": 1,
  "asset_id": "fb14f17f-a15f-4929-942d-9e1ce7101b65",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/fb14f17f-a15f-4929-942d-9e1ce7101b65/silivri-hizli-elektrikci-7-24-dukkan-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/fb14f17f-a15f-4929-942d-9e1ce7101b65/silivri-hizli-elektrikci-7-24-dukkan-1.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-1.jpg",
  "size": 149854,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:33Z"
}
